export enum AirWaybillType {
  WithNotifyParty,
  NoNotifyParty,
}
